import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackPlanUpgradeConfirmed.meta';

export type UseTrackPlanUpgradeConfirmedParams = {
  old_plan: string;
  new_plan: string;
  plan_type: 'monthly' | 'annual' | 'quarter' | 'semiAnnual';
};

export const useTrackPlanUpgradeConfirmed = () => {
  const { track } = useAnalyticsUtilities();

  const trackPlanUpgradeConfirmed = useCallback(
    (params: UseTrackPlanUpgradeConfirmedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPlanUpgradeConfirmed };
};
